import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage/session'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import appReducer from './slices/appSlice'
import ehdReducer from './slices/ehdSlice'
import bookingReducer from './slices/bookingSlice'

const persistConfig = {
  key: `prosang_3_${process.env.NODE_ENV}`,
  storage,
  // blacklist: ['pages'],
  stateReconciler: autoMergeLevel2,
}

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    app: appReducer,
    ehd: ehdReducer,
    booking: bookingReducer,
  }),
)

const rootReducer = (state, action) => {
  if (action.type === 'persist/PURGE') {
    state = {
      _persist: state._persist,
      app: {
        pages: state.app.pages,
        appSettings: state.app.appSettings,
      },
    }
  }

  return persistedReducer(state, action)
}

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(),
})

export const persistor = persistStore(store)

export default store
